import React, { useEffect, useState } from "react"
import { useSearchParams, Navigate } from "react-router-dom"
import { fetchApiPerformanceData } from "./data"
import { ApiPerformanceData } from "./types"
import Table from "./Table"
import "./styles.css"

// Private key - you can change this to any random secure key
const PRIVATE_KEY = ""

const ApiPerformance: React.FC = () => {
  const [searchParams] = useSearchParams()
  const key = searchParams.get("key")

  const [data, setData] = useState<ApiPerformanceData[]>([])
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<string | null>(null)
  const [duration, setDuration] = useState<string>("1 day ago")

  const loadData = async (selectedDuration?: string) => {
    setLoading(true)
    setError(null)

    try {
      const result = await fetchApiPerformanceData(selectedDuration || duration)
      setData(result)
    } catch (err) {
      setError(err instanceof Error ? err.message : "An unexpected error occurred")
    } finally {
      setLoading(false)
    }
  }

  const handleDurationChange = (newDuration: string) => {
    setDuration(newDuration)
    loadData(newDuration)
  }

  useEffect(() => {
    // Only load data if authenticated
    if (key && key === PRIVATE_KEY) {
      loadData()
    }
    // eslint-disable-next-line
  }, [key])

  // Redirect to home if key doesn't exist or doesn't match
  if (!key || key !== PRIVATE_KEY) {
    return <Navigate to='/' replace />
  }

  return (
    <div className='api-performance'>
      <Table 
        loading={loading} 
        error={error} 
        data={data} 
        onRetry={() => loadData()}
        duration={duration}
        onDurationChange={handleDurationChange}
      />
    </div>
  )
}

export default ApiPerformance
